<template>
  <div class="part2-main-machine">
    <div class="egg-text">
      <div class="egg-text-title">
        <i class="egg-text-title-icon"></i>
        <span class="egg-text-title-text">{{ langData.lotteryPointCost }}</span>
      </div>
      <div class="egg-text-title-text btns" @click="showBag">
        {{ langData.viewMyRewardsBtn }} >>
      </div>
    </div>
    <div class="egg-container j-egg-container">
      <i class="egg egg-1 j-egg-1"></i>
      <i class="egg egg-2 j-egg-2"></i>
      <i class="egg egg-3 j-egg-3"></i>
      <i class="egg egg-4 j-egg-4"></i>
      <i class="egg egg-5 j-egg-5"></i>
      <i class="egg egg-6 j-egg-6"></i>
      <i class="egg egg-7 j-egg-7"></i>
      <i class="egg egg-8 j-egg-8"></i>
      <i class="egg egg-9 j-egg-9"></i>
      <i class="egg egg-10 j-egg-10"></i>
      <i class="egg egg-11 j-egg-11"></i>
      <i class="egg egg-12 j-egg-12"></i>
      <i class="egg egg-13 j-egg-13"></i>
      <i class="egg egg-14 j-egg-14"></i>
      <i class="egg egg-15 j-egg-15"></i>
      <i class="egg egg-16 j-egg-16"></i>
      <i class="egg egg-17 j-egg-17"></i>
      <i class="egg egg-18 j-egg-18"></i>
      <i class="egg egg-19 j-egg-19"></i>
      <i class="egg egg-20 j-egg-20"></i>
    </div>
    <i class="egg-show j-egg-show"></i>
    <template v-if="showLotteryButtons">
      <div class="egg-btns">
        <div class="start-1 btns" @click="start('1_pull')">{{ langData.oneDraw }}</div>
        <div class="start-10 btns" @click="start('10_pull')">{{ langData.tenDraw }}</div>
      </div>

      <div class="egg-tips" v-if="showLotteryTips">{{ langData.spendPointsFirst }}</div>
    </template>

    <div
      class="get-award-btn btns"
      @click="showBag"
      v-else-if="showGetAwardButton"
    >
      <span class="get-award-btn__text">{{ langData.claimRewardsBtn }}</span>
    </div>
  </div>
</template>

<script setup>
import Animation from "@/utils/lottery-animation";
import {
  ref,
  onMounted,
  onUnmounted,
  inject,
  reactive,
  nextTick,
  computed,
} from "vue";

import { getJSON } from "@/api/request";
import { getActivityApi } from "@/utils";
import { UgcTab } from "../typings";
import LanguageHook from "@hooks/language";

const { langData } = LanguageHook();

const v3PopupState = inject("v3PopupState", reactive({}));
const lotteryResult = inject("lotteryResult", ref([]));
const showCurErrorTips = inject("showCurErrorTips", () => {});
const checkLogin = inject("checkLogin", () => {});
const initActivity = inject("initActivity", () => {});
const lotteryAndTaskState = inject("lotteryAndTaskState", reactive({}));

let animation = null;

let canStart = ref(true);

// 计算是否显示抽奖按钮
const showLotteryButtons = computed(() => {
  return !lotteryAndTaskState.isEnd || lotteryAndTaskState.totalScore >= 25;
});

// 计算是否显示领奖按钮
const showGetAwardButton = computed(() => {
  return lotteryAndTaskState.isEnd && lotteryAndTaskState.totalScore < 25;
});

// 计算是否展示提示
const showLotteryTips = computed(() => {
  return lotteryAndTaskState.isEnd && lotteryAndTaskState.totalScore >= 25;
})

const start = async (type) => {
  if (!checkLogin()) {
    return;
  }

  if (!canStart.value) return;
  canStart.value = false;
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: type == "1_pull" ? "单次抽奖" : "10次抽獎",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  animation.reset();
  let res = await getJSON(
    getActivityApi(window.platform_id, window.activity_name, "lottery"),
    {
      params: JSON.stringify({
        lotteryType: type,
      }),
    }
  );
  // let res = {
  //   code: 1,
  //   result: 1, // 0: 失败, 1: 成功
  //   msg: "success",
  //   data: {
  //     lotteryAwardList: [
  //       {
  //         awardId: "Thanks", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //         awardName: "感謝參與",
  //         awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //         awardVtId: "",
  //       },
  //       // {
  //       //   awardId: "Title", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //       // {
  //       //   awardId: "Avatar", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //       // {
  //       //   awardId: "Thanks", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //       // {
  //       //   awardId: "Thanks", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //       // {
  //       //   awardId: "Thanks", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //       // {
  //       //   awardId: "Thanks", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //       // {
  //       //   awardId: "Thanks", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //       // {
  //       //   awardId: "Thanks", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //       // {
  //       //   awardId: "Thanks", // 取值: Thanks(谢谢参与), Title(称号), Avatar(头像框), PhoneHolder(手机支架), CanvasBag(帆布包), FridgeMagnet(冰箱贴), Calendar(万年历), WaistPillow(腰靠), Headwear(头饰)
  //       //   awardName: "感謝參與",
  //       //   awardVtType: "sendNothing", // 取值: sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
  //       //   awardVtId: "",
  //       // },
  //     ],
  //   },
  // };
  if (res.result != 1) {
    showCurErrorTips(res.code);
    canStart.value = true;
    return;
  }
  lotteryResult.value = res.data.lotteryAwardList || [];
  // 播放动画
  await animation.start();
  animation.reset();
  v3PopupState.lotterySuccPopupState = true;
  window.activityDataLayer.push({ eventName: "show_popup", eventType: "抽奖成功弹窗", aid: window.activity_name, gameId: window.game_id });
  await initActivity();
  canStart.value = true;
};

const showBag = () => {
  if (!checkLogin()) {
    return;
  }
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "我的奖品",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "我的奖品",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  v3PopupState.bagPopupState = true;
};

onMounted(async () => {
  await nextTick();
  animation = new Animation();
});

onUnmounted(() => {
  animation.destroy();
  animation = null;
});
</script>

<style scoped lang="less"></style>
